import { getEmailIntegrationLabel } from './getEmailIntegrationLabel';
export function sortEmailIntegrationsList(senders) {
    return senders.slice().sort((a, b) => {
        const aLabel = getEmailIntegrationLabel(a).toLowerCase();
        const bLabel = getEmailIntegrationLabel(b).toLowerCase();
        return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
    });
}
